import React from 'react';
import classNames from 'classnames';

import Store from 'store';
import Data from 'data';

import { useDragDropManager } from 'react-dnd';
import Overlay from 'ui/utils/Overlay';

import './DragLayer.scss';

export default function DragLayer() {
  const charClass = Store.useProfile(profile => profile.class);
  const gender = Store.useProfile(profile => profile.gender);

  const dragDropManager = useDragDropManager();
  const monitor = dragDropManager.getMonitor();
  const [item, setItem] = React.useState();

  const updateState = React.useCallback(() => setItem(monitor.getItem()), [monitor]);
  React.useEffect(() => monitor.subscribeToStateChange(updateState), [monitor, updateState]);

  const previewRef = React.useRef();
  const updateOffset = React.useCallback(() => {
    if (previewRef.current) {
      const offset = monitor.getClientOffset();
      if (offset) {
        previewRef.current.style.left = `${offset.x}px`;
        previewRef.current.style.top = `${offset.y}px`;
        previewRef.current.style.visibility = "";
      } else {
        previewRef.current.style.visibility = "hidden";
      }
    }
  }, [monitor]);
  React.useEffect(() => monitor.subscribeToOffsetChange(updateOffset), [monitor, updateOffset]);

  if (!item) return null;

  if (item.type === "ITEM") {
    const info = Data.itemById[item.id];
    if (!info) return null;
    return (
      <Overlay>
        <img className="d3p-DragPreview" src={Data.getItemIcon(item.id, {class: charClass, gender})} alt={info.name} ref={previewRef}/>
      </Overlay>
    );
  }

  if (item.type === "SKILL") {
    const info = Data.skills[item.charClass][item.id];
    if (!info) return null;
    return (
      <Overlay>
        <div className={`d3p-DragPreview d3p-skill-icon d3p-class-${item.charClass}`}
             style={{backgroundPosition: `${-info.col}em ${-2 * info.row}em`}} ref={previewRef}>
          <span className="d3p-skill-frame"/>
        </div>
      </Overlay>
    );
  }

  if (item.type === "PASSIVE") {
    const info = Data.passives[item.charClass][item.id];
    if (!info) return null;
    return (
      <Overlay>
        <div className={`d3p-DragPreview d3p-passive-icon d3p-class-${item.charClass}`}
             style={{backgroundPosition: `${-info.index}em 0`}} ref={previewRef}>
          <span className={classNames("d3p-passive-frame", {"d3p-fancy": item.fancy})}/>
        </div>
      </Overlay>
    );
  }

  return null;
}
